import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m9.414 4 4 4H22v12H2V4h7.414zM4 8h6.586l-2-2H4v2zm0 10v-8h16v8H4z",
		fill: "#111"
	})
});
export default SvgFolder;
